import { IClient } from "../data/entities";

export function calcClientListSummary(clientList: IClient[]): number {
  let summary = 0;

  clientList.forEach((c) => {
    summary += c.balance;
  });

  return summary;
}
